import React from 'react';
import classNames from 'classnames';
import { useLocation, useParams } from 'react-router-dom';
import { useQuery } from 'react-apollo';
import qs from 'query-string';

import FullScreenLoader from '../../../../../components/global/FullScreenLoader';
import { RosterQrCodeExport } from '../../../../../graphql/queries/roster-identitiy';
import RosterQrCodesPrintItem from '../RosterQrCodesPrintView/components/RosterQrCodesPrintItem';

const DEFAULT_OFFSET = 0;
const DEFAULT_LIMIT = 999;

const RosterQrCodeExportPrint = () => {
  const { rosterQrCodeExportId, pdfIndex } = useParams();
  const location = useLocation();

  const { offset, limit } = qs.parse(location.search ?? '');

  const {
    data: { rosterQrCodeExport } = {},
    loading: loadingRosterQrCodeExport,
  } = useQuery(RosterQrCodeExport, {
    variables: {
      roster_qr_code_export_id: rosterQrCodeExportId,
      pdf_index: parseInt(pdfIndex, 10),
      offset: offset ? parseInt(offset, 10) : DEFAULT_OFFSET,
      limit: limit ? parseInt(limit, 10) : DEFAULT_LIMIT,
    },
  });

  if (loadingRosterQrCodeExport || !rosterQrCodeExport) {
    return <FullScreenLoader />;
  }

  const rosterQrCodes = (rosterQrCodeExport?.codes?.records || []).map(
    record => record.roster_qr_code,
  );
  const itemsPerPage = rosterQrCodeExport?.settings?.items_per_page || 1;

  const pages = Array.from(
    { length: Math.ceil(rosterQrCodes.length / itemsPerPage) },
    (_, pageIndex) =>
      rosterQrCodes.slice(
        pageIndex * itemsPerPage,
        (pageIndex + 1) * itemsPerPage,
      ),
  );

  const flyerText =
    rosterQrCodeExport?.album_folder?.roster_qr_code_settings?.flyer_text;
  const logoImage =
    rosterQrCodeExport?.album_folder?.logo_image ||
    rosterQrCodeExport?.album_folder?.account?.logo_image;

  const classes = classNames({
    'roster-qr-code-export-print': true,
    landscape: itemsPerPage === 2,
  });

  return (
    <div
      id={`roster-qr-code-export-${rosterQrCodeExportId}`}
      className={classes}
    >
      {pages.map((pageRosterQrCodes, pageIndex) => (
        <div
          key={pageIndex}
          className={`roster-qr-code-export-print-page items-per-page-${itemsPerPage}`}
        >
          {pageRosterQrCodes.map(rosterQrCode => (
            <RosterQrCodesPrintItem
              key={rosterQrCode.id}
              rosterQrCode={rosterQrCode}
              logoImage={logoImage}
              flyerText={flyerText}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default RosterQrCodeExportPrint;
